/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */

// Imports

import { Button, Column, Icon, Label, Row } from "trux"
import "./SharePlaylistCard.css"
import React from "react"

// Share Playlist Card

const SharePlaylistCard = ({ onShareClick, ...props }) => {

    const handleShareButtonClick = (e) => {
        e.preventDefault()
        if (typeof onShareClick === "function") {
            onShareClick()
        }
    }

    return (
        <Column
            className="SharePlaylistCard"
            alignItems="center"
            justifyContent="center"
            paddingLeft="4"
            paddingRight="4"
            { ...props }
        >
            <Label center type={Label.Type.Heading4}>
                Share with Coach, Friends, Family!
            </Label>
            <Button
                primary
                className="share-playlist-button"
                marginTop="8"
                trkAction="Share Playlist Pressed"
                onClick={(e) => handleShareButtonClick(e)}
                content={
                    <Row alignItems="center" justifyContent="center">
                        <Icon size={16} type={Icon.Type.Action} />
                        <Label
                            marginLeft="2"
                            type={Label.Type.InnerButton}
                            content="Share Playlist"
                        />
                    </Row>
                }
            />
        </Column>
    )
}

export { SharePlaylistCard }
